
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"525.333","height":"214.667","viewBox":"0 0 394 161"}, attrs),
              ...rest,
            },
            children.concat([_c('a',{staticStyle:{"width":"394","height":"161"},attrs:{"xlink:href":"/"}},[_c('path',{attrs:{"d":"M1.2 61l.3 60.1h37.4c20.6 0 37.6-.2 37.8-.4.2-.2-1.1-4.3-2.8-9.1l-3.2-8.6H21V1H1l.2 60zM68.1 40.2c0 .7 6.2 19.3 13.7 41.2l13.7 40 6.7-.3c3.6-.1 6.9.2 7.2.7.3.5-2.1 9-5.4 18.8-3.3 9.8-6 18.4-6 19.2 0 1 2.2 1.2 9.7 1l9.8-.3 12.7-37.5c19-56.1 27.8-82.4 27.8-83.3 0-.4-4.4-.7-9.8-.7h-9.7l-4.2 12.2C117.5 101 113.7 112 113 112c-.4 0-2.5-5.5-4.8-12.3-2.2-6.7-7.7-23.1-12.3-36.5L87.7 39h-9.8c-7.3 0-9.9.3-9.8 1.2zM172.2 80.1l.3 41.1h18l.3-33.6.2-33.6h15.9c12 0 16.1.3 17 1.3.7.9 1.2 11.9 1.3 33.6l.3 32.3h18V86.3c0-33.2-.1-35-2-38.3-6.1-10.3-23.9-11.5-41.7-2.7l-8.8 4.3V39h-19l.2 41.1zM264.2 80.1l.3 41.1h18l.5-33.4.5-33.3 14.5-.3c8-.1 15.5 0 16.8.3l2.2.5v65.9l9.1.3c5 .2 9.3.1 9.5-.1 1-1 .3-68.1-.7-70.8-4.6-12.3-24-14.4-43.5-4.8-4 1.9-7.5 3.5-7.8 3.5-.3 0-.6-2.3-.6-5v-5h-19l.2 41.1z"}}),_c('path',{attrs:{"fill":"#888","d":"M366.1 84.2c-1.9.5-5.1 2.3-7.2 4-9.7 7.8-9.1 24.7 1.2 31.5 3.7 2.5 5.2 2.8 11.9 2.8 6.5 0 8.2-.4 11.3-2.5 10.3-7 11.4-22.4 2.2-30.9-6-5.5-12-7.1-19.4-4.9z"}})])])
          )
        }
      }
    